module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Gallery-baf277dda0b6ec7bdbdc1df109503b21.png";